import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { STEPS, ALL_STEPS, ALL_STEPS_LABELS, STEPS_LABELS } from './constants';
import { getCurrentStep, getImport, getImportRequest } from './store/selectors';

export function Steps({ currentStep, importer, importRequest }) {
  const [importStatus, setImportStatus] = useState(
    importer ? ALL_STEPS.find(step => step.status === importer.statusType) : STEPS[currentStep]
  );
  const current = STEPS[currentStep];
  const history = useHistory();

  const handleSelectStep = (step) => {
    if (isDisable(step)) return;

    history.push(`/${importRequest.id}/${step.url}`);
  };

  const isDisable = (step) => {
    return step.page > importStatus.page ||
    (step.page != importStatus.page && importStatus.status === STEPS[STEPS_LABELS.REVIEW].status);
  };

  useEffect(() => {
    if (!importer) return;

    setImportStatus(ALL_STEPS.find(step => step.status === importer.statusType));
  }, [importer]);

  return (
    <div className="container importer-imports">
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <ul className="nav nav-pills nav-justified thumbnail setup-panel">
              {
                ALL_STEPS.map(step => (
                  <li
                    className={
                      classNames({
                        'active': step.page === current.page,
                        'disabled': isDisable(step)
                      })
                    }
                    key={step.page}
                  >
                    <a onClick={() => handleSelectStep(step)}>
                      <h1 className="list-group-item-heading">{step.page}</h1>
                      <p className="list-group-item-text">{step.label}</p>
                    </a>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

Steps.propTypes = {
  currentStep: PropTypes.oneOf(ALL_STEPS_LABELS).isRequired,
  importer: PropTypes.object,
  importRequest: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  importer: getImport(state),
  importRequest: getImportRequest(state)
});

export default connect(mapStateToProps, null)(Steps);
